export default "__VITE_ASSET__CfpzyMAQ__"